// Chat glyphs: icons only this lane uses (docs/implement/lanes.md).
// Key = the icon's name, value = a lucide-react component, as in Icon.tsx.

export { chatGlyphs };

import { GitPullRequestArrow, ShieldAlert, ShieldOff } from "lucide-react";
import type { AreaGlyphs } from "../Icon";

const chatGlyphs = {
    "git-pull-request-arrow": GitPullRequestArrow, // a proposal (pen "Proposal" kicker)
    "shield-alert": ShieldAlert, // partly backed by your sources
    "shield-off": ShieldOff, // not backed by your sources
} satisfies AreaGlyphs;
